import PNFO from 'jlinc-shared/PNFO'

export const GENERAL_CHANNEL_NAME = `${PNFO.singular} Chat`
